<template>
	<div class="m_all_overlay">
		<div class="m_all_dialog" :style="{ width: width }">
			<div class="m-subscribe-con" :style="!background ? 'background:none' : ''">
				<i class="iconfont iconguanbiicon" @click.stop="handleCancel"></i>
				<img src="~@/assets/images/sub.svg" alt="" class="subscribe-icon" v-if="background" />
				<p class="subscribe-success">{{ title || calcInfo.title }}</p>
				<p v-html="content || calcInfo.content" class="subscribe-content"></p>
				<div style="width: 100%">
					<div
						class="subscribe-action"
						:class="{ 'action-disabled': calcInfo.disabled }"
						@click.stop="handleConfirm"
					>
						{{ btnText || calcInfo.btnText }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { isIos, isWxMiniProgram } from '@/utils/api';
import { translate } from '@/assets/js/i18n';
/**
 * 	公开状态openstatus
 *  0: 私密
 *	1: 公开
 *	2: 专场（包含机构和专场活动）
 *	3: 私募
 *	4: 课程
 *	5: 开户分仓
 *	6: 实名认证
 *	7: 申请参会
 *	8: 投资调研
 *	9: 专栏路演
 *	10: 付费路演
 *	12: 会员
 *
 * 公开/私密 openstatus=0/1
 * 报名参会 openstatus=7
 * 白名单 openstatus=8 || (openstatus=2&&isInstitute=0)
 * 机构通 isInstitute=1
 * 专栏/课堂 openstatus=4/9
 * 会员 openstatus=12
 * 付费路演 openstatus=10
 *
 * 3/5/6应该去掉了
 */
const temp = Object.create(null);
Object.assign(temp, {
	'2': {
		// 白名单
		title: '预约成功',
		content: '本场路演仅针对<span>白名单</span>客户开放',
		btnText: '查看详情'
	},
	'4': {
		// 课程
		title: '预约成功',
		content: '本场路演需购买<span>课程</span>后才能观看',
		btnText: '购买课程'
	},
	'7': {
		// 报名参会
		title: '预约成功',
		content: '本场路演需<span>报名</span>审核通过才能参会',
		btnText: '报名参会'
	},
	'7_1': {
		// 报名参会
		title: '预约成功',
		content: '本场路演需<span>报名</span>审核通过才能参会',
		btnText: '报名审核中，请稍后',
		disabled: true
	},
	'8': {
		// 投资调研
		title: '预约成功',
		content: '本场路演需<span>报名</span>审核通过才能参会',
		btnText: '报名参会'
	},
	'8_1': {
		// 投资调研
		title: '预约成功',
		content: '本场路演需<span>报名</span>审核通过才能参会',
		btnText: '报名审核中，请稍后',
		disabled: true
	},
	'9': {
		// 专栏
		title: '预约成功',
		content: '本场路演需购买<span>专栏</span>后才能观看',
		btnText: '购买专栏'
	},
	'10': {
		// 付费路演
		title: '预约成功',
		content: '本场路演需<span>购买</span>后才能观看',
		btnText: '立即购买'
	},
	'12': {
		title: '预约成功',
		content: '本场路演需购买<span>会员</span>后才能观看',
		btnText: '购买会员'
	},
	'99': {
		// 机构通
		title: '预约成功',
		content: '本场路演需完成<span>机构投资者认证</span>才能参会',
		btnText: '认证机构投资者'
	},
	'99_1': {
		// 机构通
		title: '预约成功',
		content: '本场路演需完成<span>机构投资者认证</span>才能参会',
		btnText: '认证审核中，请稍后',
		disabled: true
	},
	'101': {
		// 正在直播（有权限）
		title: '正在直播',
		content: '当前路演直播已开始',
		btnText: '进入会议'
	},
	'102': {
		// 路演回放（有权限）
		title: '路演回放',
		content: '当前路演已发回放',
		btnText: '观看回放'
	},
	'103': {
		// 嘉宾正在准备路演
		title: '即将开始',
		content: '嘉宾正在准备路演，请稍后',
		btnText: '进入会议'
	},
	'104': {
		// 会议已结束，回放生成中
		title: '会议已结束',
		content: '会议已结束，请稍后观看回放',
		btnText: ''
	},
	'105': {
		// 会议已结束，不保留回放
		title: '会议已结束',
		content: '会议已结束，本场会议不提供回放',
		btnText: ''
	},
	'999': {
		title: '预约成功',
		content: '预约成功，可在“我的路演”或“进门<br>APP日历”菜单中查看',
		btnText: ''
	}
});

if (isIos && isWxMiniProgram) {
	// iOS 环境下微信小程序不能出现购买虚拟产品，这里屏蔽购买按钮
	temp['4'] =
		temp['9'] =
		temp['10'] =
		temp['12'] =
			{
				title: '预约成功',
				content: '应小程序要求，该路演请前往<span>进门APP</span>观看',
				btnText: '知道了'
			};
}

export default {
	name: 'YuYueDialog',

	props: {
		visible: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ''
		},
		type: {
			type: [Number, String],
			required: true
		},
		width: {
			// 尺寸-width
			type: String,
			default: '78%'
		},
		content: {
			type: String,
			default: ''
		},
		btnText: {
			type: String,
			default: ''
		},
		background: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {};
	},
	computed: {
		calcInfo() {
			const tempInfo = temp[this.type];
			tempInfo.title = translate(tempInfo.title);
			tempInfo.content = translate(tempInfo.content);
			tempInfo.btnText = translate(tempInfo.btnText);
			return tempInfo || {};
		}
	},

	methods: {
		handleCancel() {
			if (this.cancel) {
				this.cancel();
			}
		},
		handleConfirm() {
			if (!this.calcInfo.btnText || this.calcInfo.disabled) return;
			if (this.calcInfo.btnText === translate('知道了')) {
				this.handleCancel();
				return;
			}
			if (this.confirm) {
				this.confirm();
			}
		}
	}
};
</script>

<style lang="less" scoped>
.m_all_overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 101;
	background-color: rgba(0, 0, 0, 0.3);
	display: flex;
	justify-content: center;
	align-items: center;
	touch-action: none;
}

.m_all_dialog {
	width: 78%;
	min-height: 100px;
	border-radius: 0.04rem;
	background-color: #fff;
	position: relative;
}

.m-subscribe-con {
	padding: 0.24rem 0 0.14rem;
	overflow: hidden;
	background: linear-gradient(180deg, #ffd7c2 0%, #ffffff 39.46%);
	border-radius: 2px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;

	&::after {
		content: '';
		position: absolute;
		top: -0.84rem;
		left: 1.8rem;
		width: 1.42rem;
		height: 1.42rem;
		z-index: 1;
		border-radius: 50%;
		background: linear-gradient(122.29deg, #ffffff 25.71%, rgba(255, 255, 255, 0) 69.19%);
		opacity: 0.32;
	}

	.subscribe-icon {
		width: 0.8rem;
		height: auto;
	}

	.subscribe-success {
		font-weight: 500;
		font-size: 16px;
		line-height: 22px;
		text-align: center;
		color: #12121a;
		margin: 0.16rem 0 0.1rem;
	}

	.subscribe-content {
		font-size: 0.13rem;
		line-height: 0.22rem;
		text-align: center;
		color: #8e8d8c;

		/deep/ span {
			color: #ff661a;
		}
	}

	.subscribe-action {
		margin: 0.22rem 0.14rem 0;
		background: linear-gradient(90deg, #ffaf62 0%, #ff661a 100%);
		border-radius: 0.02rem;
		font-size: 0.15rem;
		line-height: 0.34rem;
		text-align: center;
		color: #ffffff;
	}
	.action-disabled {
		background: linear-gradient(90deg, #ffaf62 0%, #ff661a 100%);
		opacity: 0.5;
		pointer-events: none;
	}

	.iconguanbiicon {
		position: absolute;
		top: 0.14rem;
		right: 0.14rem;
		font-size: 0.2rem;
		z-index: 2;
	}
}
</style>
